// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2iltx","emails":"CreateEditClinics_emails__3tqLK","emailTagLabel":"CreateEditClinics_emailTagLabel__a1ySb"};